import React from 'react';

import { Button, Group, LoadingOverlay, Stack, Text } from '@mantine/core';
import useDeletePayRate from 'hooks/payRate/useDeletePayRate';
import { PayRate } from 'types';
import notificationHandler from 'utils/notifications';

const DeletePayRateModal = ({
  payRate,
  handleClose,
}: {
  payRate?: PayRate;
  handleClose: () => void;
}): JSX.Element => {
  const deleteMutation = useDeletePayRate();

  const handleDelete = (): void => {
    const { successNotification, errorNotification } = notificationHandler();
    if (payRate) {
      deleteMutation.mutate(payRate.payRateId, {
        onSuccess: () => {
          successNotification('Pay Rate delete success', `${payRate.name} successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Pay Rate delete failed', error.message);
        },
      });
    }
  };

  return (
    <Stack>
      <LoadingOverlay visible={!payRate} />
      <Text>{`Are you sure you want to delete this pay rate?`}</Text>
      <Text color='dimmed'>This action cannot be undone.</Text>
      <Group position='right'>
        <Button
          onClick={handleDelete}
          color='red'
          loading={deleteMutation.isLoading}
          disabled={!payRate}
          data-cy='deletePayRateButton'
        >
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeletePayRateModal;
